import React, { useState } from 'react';
import Popup from '../Modals/Popup';

export default function EditNotes({ button, leadData, updateLeadDataMultiple }){

  const [show, setShow] = useState(false);

  const [formData,setFormData] = useState({
    'full_name':leadData && leadData.name,
    'vehicle_name':leadData && leadData.vehicle,
    'location':leadData && leadData.location,
    'phone':leadData && leadData.phone,
    'lead_type':leadData && leadData.lead_type
  });

  const handleInputChange = (e) => {
    setFormData({...formData,[e.target.name]:e.target.value});
  };    


  const openPopup = () => {
    setShow(true);
  };

  const closePopup = () => {
    setShow(false);
  };

  const updateItem = () => {
    console.log("updatedItems",formData);

    var values = {...formData,["id"]:leadData.id}

    console.log(formData,values);

    updateLeadDataMultiple(values);

    closePopup();
  };


  return (
    <>
      {button && <div onClick={openPopup}>{button}</div>}
      <Popup action={show ? 'open' : ''} button={button} >
        <h2 className="headingedit mb-1">Edit Details</h2>
        <input type="hidden" name="lead_type" value={formData.lead_type || ""} />
        <input placeholder='Enter name' onChange={handleInputChange} value={formData.full_name || ""} name="full_name" className='editnote-textarea input mb-1'></input>
        <input placeholder='Enter phone number' onChange={handleInputChange} value={formData.phone || ""} name="phone" className='editnote-textarea input mb-1'></input>
        <input placeholder='Enter vehicle' onChange={handleInputChange} value={formData.vehicle_name || ""} name="vehicle_name" className='editnote-textarea input mb-1'></input>
        
        <select defaultValue={formData.location || ""} onChange={handleInputChange} name="location" className='editnote-textarea input mb-1'>
          <option value="Boynton Beach">Boynton Beach</option>
          <option value="Pompano Beach" >Pompano Beach</option>
        </select>
        
        <button onClick={updateItem} className="editbtn">
          Update
        </button>
      </Popup>
    </>
  );
}
